import { render, staticRenderFns } from "./dongtai.vue?vue&type=template&id=1e545e3e&scoped=true"
import script from "./dongtai.vue?vue&type=script&lang=js"
export * from "./dongtai.vue?vue&type=script&lang=js"
import style0 from "./dongtai.vue?vue&type=style&index=0&id=1e545e3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e545e3e",
  null
  
)

export default component.exports